import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useUILogic } from '../../../shared/providers/UILogicProvider/hooks';
import { RegisterStep } from '../../../../infrastructure/types/features/auth/auth-types';
import { PhoneEnterForm } from '../PhoneEnterForm';
import { PhoneConfirmation } from '../PhoneConfirmation';
import { RegisterForm } from '../RegisterForm';
import { YandexCloudNotice } from '../YandexCloudNotice';
import { ChangePhoneForm } from '../ChangePhoneForm';

interface RegisterWrapperProps {}

let RegisterWrapper = function ({}: RegisterWrapperProps): ReactElement {
  const { authorizationUiModule } = useUILogic();
  const registerUIManager = authorizationUiModule.registerUIManager;

  const getStep = () => {
    switch (registerUIManager.coreManager.step) {
      case RegisterStep.ENTER_PHONE:
        return <PhoneEnterForm />;
      case RegisterStep.CONFIRM_PHONE:
        return <PhoneConfirmation />;
      case RegisterStep.CHANGE_PHONE:
        return <ChangePhoneForm />;
      case RegisterStep.FORM:
        return <RegisterForm />;
    }
  };

  return (
    <Wrapper>
      <YandexCloudNotice page="register" />
      {getStep()}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

RegisterWrapper = observer(RegisterWrapper);

export { RegisterWrapper };
